import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"line-chart-2, statistics, graph"} maskId="square-filled-radius-0-stroke-1-IconLineChart2"><path d="M9.33203 19.75V4H8.33203V19.75H9.33203Z" fill="currentColor"/><path d="M3 19.75V10H2V19.75H3Z" fill="currentColor"/><path d="M15.6641 13V19.75H14.6641V13H15.6641Z" fill="currentColor"/><path d="M21.9961 19.75V7H20.9961V19.75H21.9961Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLineChart2;
